module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-picker"
  }, [_c('flexbox', {
    attrs: {
      "gutter": 0
    }
  }, _vm._l((_vm.currentData), function(one, index) {
    return _c('flexbox-item', {
      key: index,
      staticStyle: {
        "margin-left": "0"
      },
      attrs: {
        "span": _vm.columnWidth && _vm.columnWidth[index]
      }
    }, [_c('div', {
      staticClass: "vux-picker-item",
      attrs: {
        "id": ("vux-picker-" + _vm.uuid + "-" + index)
      }
    })])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-660281b3"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/picker/index.vue
// module id = 572
// module chunks = 0